export default "__VITE_ASSET__BQHufT3e__"